import { Params, useQueryWithParams } from 'hooks/useQueryWithParams'
import { FIND_ALL_CODES } from 'queries/institutionalCodes'
import { FindAllCodes, FindAllCodesVariables } from '__generatedTypes__/FindAllCodes'
import { SearchTypeEnum, CodesWhere, RolesEnum } from '__generatedTypes__/globalTypes'

export type CodesFilters = {
  institutionalCodes?: { id: string }
  userRole?: RolesEnum
}

export function castParams({ page, take, search, order, filters }: Params<CodesFilters>): FindAllCodesVariables {
  const where: CodesWhere = {}

  if (filters.userRole) {
    where.userRole = filters.userRole
  }

  if (filters.institutionalCodes) {
    where.institutionalCodes = filters.institutionalCodes
  }

  return {
    query: {
      skip: (page - 1) * take,
      take,
      search: search ? { query: search, type: SearchTypeEnum.ILike } : undefined,
      order: order?.field ? { [order.field]: order.direction } : undefined,
      where,
    },
  }
}

export function useFindAllCodesWithQueryParams() {
  return useQueryWithParams<FindAllCodes, FindAllCodesVariables, 'findAllCodes', 'items', 'count', CodesFilters>(
    FIND_ALL_CODES,
    'findAllCodes',
    'items',
    'count',
    castParams
  )
}
